var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurecricket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17.2617 29.5814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 29.5814,
    opacity: 0,
    width: 17.2617,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24219 11.7731C8.63672 11.7731 9.77344 10.6364 9.77344 9.2067C9.77344 7.80045 8.63672 6.66373 7.24219 6.66373C5.8125 6.66373 4.67578 7.80045 4.67578 9.2067C4.67578 10.6364 5.8125 11.7731 7.24219 11.7731ZM1.19531 29.5739L7.24219 29.5739C7.96875 29.5739 8.30859 29.2223 8.42578 28.5778L9.45703 22.9294L14.2383 22.9294L13.3008 28.1325C13.1602 28.9645 13.7109 29.5153 14.3203 29.5739C14.9062 29.6325 15.5508 29.3512 15.6914 28.5778L16.8633 22.0505C17.0156 21.1364 16.4883 20.5856 15.832 20.5153L11.5781 20.0465L11.9414 16.0153C11.9531 15.8161 12.1172 15.6872 12.3047 15.6872L15.7031 15.6872C16.3594 15.6872 16.9102 15.1247 16.9102 14.4684L16.9102 7.82389C16.9102 7.3317 16.6055 6.88639 16.1484 6.71061C15.7031 6.52311 15.1875 6.60514 14.8359 6.9567L8.21484 13.6012C7.62891 14.1872 7.25391 14.9255 7.17188 15.8278L6.12891 27.1598L1.19531 27.1598C0.527344 27.1598 0 27.6872 0 28.3551C0 29.0231 0.527344 29.5739 1.19531 29.5739ZM14.4961 10.7419L14.4961 13.2497L11.9648 13.2497ZM12.0703 7.19108L14.7891 9.61686L15.4219 8.91373L12.7383 6.47623ZM5.35547 2.2692L11.543 7.84733C11.918 8.18717 12.4102 8.14029 12.7734 7.76529L13.3945 7.13248C13.7695 6.75748 13.6992 6.23014 13.3359 5.89029L7.11328 0.288732C6.73828-0.0511118 6.21094-0.0159556 5.87109 0.359044L5.28516 1.03873C4.95703 1.41373 4.96875 1.91764 5.35547 2.2692Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurecricket);
export default __webpack_public_path__ + "static/media/figure.cricket.34323958982eb0cc3d9e60b470c01259.svg";
export { ForwardRef as ReactComponent };